import { ChevronRightIcon } from '@heroicons/react/24/outline'
import "./styles.scss";

function BreadCrumbs() {
  return (
    <div className="tw-bg-primary tw-font-bold bc-border-bottom tw-relative tw-z-10">
      <div className="tw-container tw-mx-auto tw-text-xs tw-p-2 tw-flex tw-items-center">
        <a href="https://hsc.unm.edu/" className="tw-mr-2 hover:tw-underline">
          Home
        </a>
        <ChevronRightIcon className="tw-h-3 tw-w-3 tw-mr-2 "/>
        <a href="https://hsc.unm.edu/about/" className="tw-mr-2 hover:tw-underline">
          About
        </a>
        <ChevronRightIcon className="tw-h-3 tw-w-3 tw-mr-2 "/>
        <a href="https://hsc.unm.edu/about/wellness/" className="tw-mr-2 hover:tw-underline">
          Wellness
        </a>
        <ChevronRightIcon className="tw-h-3 tw-w-3 tw-mr-2 "/>
        <a href="https://hsc.unm.edu/about/wellness/artwalk/" className="tw-mr-2 hover:tw-underline">
          Art Walk
        </a>
      </div>
    </div>
  );
}
export default BreadCrumbs;
